import React from "react";
import { Box } from "@mui/material";
import AnimatedOrb from "./AnimatedOrb";
import GradientButton from "../../input/GradientButton";

/**
 * The "Task Guide" card on the dashboard — replaces the old Focus Guide button.
 * Shows a beautiful animated orb with a gradient button label underneath.
 * Clicking it opens the TaskGuideDialog.
 * When the user has no tasks, the button text changes to "Get started".
 */
const TaskGuideCard = ({ onClick, hasNoTasks }) => {
  const buttonText = hasNoTasks ? "Get started" : "Focus guide";

  return (
    <Box className="task-guide-card" onClick={onClick}>
      <Box className="task-guide-card__orb-container">
        <AnimatedOrb size="large" intensity="idle" />
      </Box>
      <GradientButton
        text={buttonText}
        size="small"
        sx={{ mt: 1.5, pointerEvents: "none" }}
      />
    </Box>
  );
};

export default TaskGuideCard;
